import React from "react";
import Layout2 from "components/layout/Layout2";
import Main from "./Main";

const Committee = (props) => {
  return (
    <Layout2>
      <Main {...props} />
    </Layout2>
  );
};

export default Committee;
